import { atom, selector } from "recoil";
import { recoilPersist } from "recoil-persist";
const { persistAtom } = recoilPersist();


export const localeState = atom({
  key: "localeState",
  default: {},
});

export const languageState = atom({
  key: 'languageState',
  default: 'enUS', // ค่าเริ่มต้น
});

export const themeState = atom({
  key: "themeState",
  default: localStorage.getItem('themeMode') || 'light',
});